import { render, staticRenderFns } from "./editReturnShop.page.vue?vue&type=template&id=696a45c5&scoped=true&"
import script from "./editReturnShop.page.vue?vue&type=script&lang=js&"
export * from "./editReturnShop.page.vue?vue&type=script&lang=js&"
import style0 from "./editReturnShop.page.vue?vue&type=style&index=0&id=696a45c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a45c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696a45c5')) {
      api.createRecord('696a45c5', component.options)
    } else {
      api.reload('696a45c5', component.options)
    }
    module.hot.accept("./editReturnShop.page.vue?vue&type=template&id=696a45c5&scoped=true&", function () {
      api.rerender('696a45c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/returnShop/editReturnShop.page.vue"
export default component.exports